class BESSAppDependentView extends BESSAppBase {

    constructor(node, dependencies, extra = null, postShowHideFn = null) {
        super();
        this.node = node;
        this.dependencies = dependencies;
        this.show = [];
        this.extra = extra;
        this.specialDependencies = {
            'EnergyDontUseUnconditionedDTSDependency': BESSAppProjectDependencyAndSubDependency,
            'EnergyUseUnconditionedDTSDependency': BESSAppProjectDependencyOrSubDependency,
            'IEQCalcsAnsweredDependency': BESSAppProjectDependencyOrSubDependency,
        }
        this.postShowHideFn = postShowHideFn;
        this.forEach(dependencies, this.#setupDependency);
    }

    #setupDependency(dependency) {
        this.show.push(false);

        if (dependency.dependencyClass in this.specialDependencies) {
            return new this.specialDependencies[dependency.dependencyClass](this, dependency);
        }

        if (dependency.type === BESSAppProjectDependencyType.projectQAValue) {
            return new BESSAppProjectQuestionAnswerDependency(
                dependency.questionIdentifier,
                new BESSAppProjectVisibilityDependencyHandler(
                    this.node,
                    questionValueIs(dependency.questionValue),
                    this.getShowIfFn(dependency))
            );
        }

        if (dependency.type === BESSAppProjectDependencyType.itemQAValue) {
            return new BESSAppProjectItemQuestionAnswerDependency(
                this.extra.item,
                dependency.questionIdentifier,
                new BESSAppProjectVisibilityDependencyHandler(
                    this.node,
                    questionValueIs(dependency.questionValue),
                    this.getShowIfFn(dependency))
            );
        }

        if (dependency.type === BESSAppProjectDependencyType.itemQASelected) {
            return new BESSAppProjectItemQuestionAnswerDependency(
                this.extra.item,
                dependency.questionIdentifier,
                new BESSAppProjectVisibilityDependencyHandler(
                    this.node,
                    questionSelectionValueIsAnswered,
                    this.getShowIfFn(dependency))
            );
        }

        if (dependency.type === BESSAppProjectDependencyType.siteType) {
            return new BESSAppProjectSiteTypeDependency(
                new BESSAppProjectVisibilityDependencyHandler(
                    this.node,
                    siteTypeQualifies(dependency.siteTypes),
                    this.getShowIfFn(dependency))
            );
        }

        if (dependency.type === BESSAppProjectDependencyType.hasItems) {
            return new BESSAppHasItemsTypeDependency(
                dependency.editorType,
                new BESSAppProjectVisibilityDependencyHandler(
                    this.node,
                    (x) => x,
                    this.getShowIfFn(dependency))
            );
        }

        if (dependency.type === BESSAppProjectDependencyType.projectQAValueIsAnswered) {
            return new BESSAppProjectQuestionAnswerDependency(
                dependency.questionIdentifier,
                new BESSAppProjectVisibilityDependencyHandler(
                    this.node,
                    questionValueIsAnswered,
                    this.getShowIfFn(dependency))
            );
        }

        if (dependency.type === BESSAppProjectDependencyType.creditIsEnabled) {
            return new BESSAppProjectCreditEnabledDependency(
                dependency.creditCode,
                new BESSAppProjectVisibilityDependencyHandler(
                    this.node,
                    creditIsEnabled,
                    this.getShowIfFn(dependency))
            );
        }
    }

    getShowIfFn(dependency) {
        return function (condition, animated, value = null) {
            this.#showNode(dependency, condition, animated, value);
        }.bind(this)
    }

    #showNode(dependency, condition, animated, value = null) {
        let index = this.dependencies.indexOf(dependency);
        this.show[index] = condition;
        let showAll = _.filter(this.show, (x) => !x).length === 0;

        this.node.addClassIf('dependency-hidden', !showAll);

        if (this.node.showAnimatedIf(showAll, animated)) {
            this.fireEvent(new BESSAppViewUpdatedEvent(this.node), true);
        }
        if (this.postShowHideFn) {
            this.postShowHideFn(showAll, value);
        }
    }
}